/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { ONBOARD_MINTER } from "../pages/OnboardMinter/graphql";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { toast } from "react-hot-toast";
import {FORM_DATA,formDataDs,useFormDataDs} from "../pages/MinterOnboard/provider"
import { formDataBrandTypeDs} from "../pages/OnboardMinter/provider"

const MODULE_NAME = "OnboardMinterService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class OnboardMinterService {
    private static instance: OnboardMinterService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): OnboardMinterService {
        if (!OnboardMinterService.instance) {
            OnboardMinterService.instance = new OnboardMinterService(props);
        }
        return OnboardMinterService.instance;
    }
    async onBoardMinter(formData: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `data in service 2`, formData);
       
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: ONBOARD_MINTER,
                    variables: {
                        ...formData,
                        brandType:formDataBrandTypeDs?.get(FORM_DATA)?.value,
                        
                        platformFee: parseFloat(formData?.platform_fee)
                    },
                    fetchPolicy:"no-cache"
                });
                console.log("resyut",res)
                log.success(MODULE_NAME, "getCreateAsset: ", res);
                if(res?.data?.createOnboarding){
                    return res?.data;
                }
            }
          
        } catch (err:any) {
            log.blue("create asset error",err?.graphQLErrors)
            err?.graphQLErrors &&
            Array.isArray(err?.graphQLErrors) &&
            err?.graphQLErrors.length > 0 &&
            toast.error(err?.graphQLErrors[0]?.message);
        }
    }

    async minterOnBoard(formData: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `data in service 2`, formData);
       
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: ONBOARD_MINTER,
                    variables: {
                        ...formData,
                       brandType: formDataDs?.get(FORM_DATA)?.value,
                        
                        platformFee: parseFloat(formData?.platform_fee)
                    },
                    fetchPolicy:"no-cache"
                });
                console.log("resyut",res)
                log.success(MODULE_NAME, "getCreateAsset: ", res);
                if(res?.data?.createOnboarding){
                    return res?.data;
                }
            }
          
        } catch (err:any) {
            log.blue("create asset error",err?.graphQLErrors)
            err?.graphQLErrors &&
            Array.isArray(err?.graphQLErrors) &&
            err?.graphQLErrors.length > 0 &&
            toast.error(err?.graphQLErrors[0]?.message);
        }
    }
}